<template>
  <main>
    <div>
      <section class="organism-discovery_discovery-node">
        <div class="discovery-node__header">
          <label class="header__text--title">Discovery Node</label>
          <atom-button
            v-if="!SNMPList.length && !WMIList.length"
            class="header__button"
            buttonId="button-snmp-community"
            @click="clickButtonSNMPCommunity"
          >
            <template>Create SNMP Community</template>
          </atom-button>
          <atom-button
            v-if="SNMPList.length || WMIList.length"
            class="header__button"
            buttonId="button-snmp-community"
            buttonStyle="border"
            @click="clickButtonSNMPCommunity"
          >
            <template>SNMP<span class="d-none">/WMI</span> Credential</template>
          </atom-button>
        </div>
        <div class="discovery-node__content">
          <molecule-data-table
            v-model="inputSearchTable"
            :fields="fields"
            :items="items"
            :isCustomized="true"
            :isShowPagination="false"
            :enabledSelect="true"
            placeholderSearch="Filter Nodes"
            maxHeight="621px"
            @onRowClick="onRowClick"
            @selectionChanged="selectionChanged"
          >
            <template #leftOfSearch>
              <div class="content__search">
                <div class="search__input">
                  <atom-input
                    title="Search by Subnet"
                    :isOnlyIcon="true"
                    placeholder="101.0.1.0/24"
                    v-model="inputSearchSubnet"
                    :isDisable="isDisableInput"
                  ></atom-input>
                </div>

                <atom-button
                  buttonId="button-search"
                  :isDisable="isDisableButtonSearch"
                  iconLeft="SearchIcon"
                  @click="clickButtonSearch"
                  class="search__button"
                >
                </atom-button>
              </div>
            </template>

            <template #emptyData>
              <div class="content__empty-data">
                <feather-icon
                  icon="CloudOffIcon"
                  class="empty-data__icon"
                ></feather-icon>
                <label class="empty-data__text--title">No Data</label>
                <label class="empty-data__text--body"
                  >Please Search Subnet</label
                >
              </div>
            </template>

            <template #hostname="data">
              {{ data.row.hostname }}
            </template>
            <template #ipAddress="data">
              {{ data.row.ipAddress }}
            </template>
            <template #cpu="data">
              <div class="container--center">{{ data.row.cpu }}</div>
            </template>
            <template #memory="data">
              <div class="container--center">{{ data.row.memory }}</div>
            </template>
            <template #storage="data">
              <div class="container--center">{{ data.row.storage }}</div>
            </template>
            <template #description="data">
              <span class="content__data">{{ data.row.description }}</span>
            </template>
          </molecule-data-table>
        </div>

        <div class="discovery-node__footer footer__top--content">
          <label class="footer__text text-secondary">
            Showing {{ items.length }} entries
          </label>
        </div>
        <hr />
        <div class="discovery-node__footer footer__bottom--content">
          <div class="footer__select-policy-and-tag row">
            <div class="select-policy_container col-12 col-sm-4">
              <div class="select-policy-topic">
                <span>Select Policy <span class="text-danger">*</span></span>
                <div id="info-tooltip" class="info-icon_container">
                  <feather-icon
                    icon="InfoIcon"
                    stroke="#6E6B7B"
                    class="info-icon--size"
                  />
                </div>
                <b-tooltip
                  target="info-tooltip"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  >Please select policy to set monitoring threshold for
                  equipment resources (ex. Cpu, Memory, Storage)</b-tooltip
                >
              </div>
              <atom-select
                v-model="selectedPolicy"
                :option="PolicyNameList"
                :isClearable="false"
                :isDisable="isDisableButtonAddEquipment"
              ></atom-select>
              <atom-checkbox
                class="enable-monitor"
                v-model="isEnableMonitor"
                title="Enable Monitoring"
                :isDisable="isDisableButtonAddEquipment"
              ></atom-checkbox>
            </div>
            <div class="select-tag_container col-12 col-sm-8">
              <div class="tag-topic">
                <span>Tag (optional)</span>
              </div>
              <atom-multi-select
                v-model="selectedTagList"
                :option="tagsList"
                :isPushTaggable="true"
                :isDisable="isDisableButtonAddEquipment"
                placeholder="Select Tag"
              ></atom-multi-select>
            </div>
          </div>
          <div class="d-flex justify-content-end mt-3 mt-sm-2">
            <atom-button
              buttonId="organism-discovery--button-add-equipment"
              :isDisable="isDisableButtonAddEquipment"
              @click="clickButtonAddEquipment"
            >
              <template>Add Equipment</template>
            </atom-button>
          </div>
        </div>
      </section>

      <molecule-modal-discovery-credential
        modalId="modal-discovery-credential"
        :SNMPList="SNMPList"
        :WMIList="WMIList"
        @addCredentialsBySnmp="addCredentialsBySnmp"
        @addCredentialsByWmi="addCredentialsByWmi"
        @deleteCredentialsBySnmp="deleteCredentialsBySnmp"
        @deleteCredentialsByWmi="deleteCredentialsByWmi"
      ></molecule-modal-discovery-credential>
      <molecule-modal-confirm-add-equipment
        modalId="modal-confirm-and-equipment"
        :selectedPolicy="selectedPolicy"
        :selectedTagList="selectedTagList"
        :selectedEquipmentList="selectedEquipmentList"
        @confirmAddEquipment="confirmAddEquipment"
      ></molecule-modal-confirm-add-equipment>
    </div>
    <footer style="height: 28px"></footer>
  </main>
</template>

<script>
import { BCard, VBTooltip, BTooltip } from "bootstrap-vue"
import Ripple from "vue-ripple-directive"
import MoleculeDataTable from "@/components/molecules/MoleculeDataTable.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import MoleculeModalDiscoveryCredential from "@/components/molecules/serverManagementModule/discovery/MoleculeModalDiscoveryCredential.vue"
import MoleculeModalConfirmAddEquipment from "@/components/molecules/serverManagementModule/discovery/MoleculeModalConfirmAddEquipment.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
import AtomCheckbox from "@/components/atoms/AtomCheckbox.vue"
export default {
  name: "OrganismDiscovery",
  components: {
    BCard,
    MoleculeDataTable,
    AtomButton,
    AtomInput,
    MoleculeModalDiscoveryCredential,
    MoleculeModalConfirmAddEquipment,
    AtomSelect,
    AtomMultiSelect,
    BTooltip,
    AtomCheckbox,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  props: {
    fields: {
      type: Array,
      required: true,
      //value = [{field: String, label: String, sortable: Boolean}, ...]
    },
    items: {
      type: Array,
      required: true,
      //value = [{field: value, ...}, ...]
    },
    policyList: {
      type: Array,
      required: true,
      // value = [{policyId: value, policyName: value}]
    },
    tagsList: {
      type: Array,
      required: true,
      // value = [string]
    },
    SNMPList: {
      type: Array,
      required: true,
      // value = [string]
    },
    WMIList: {
      type: Array,
      required: true,
      // value = [string]
    },
  },
  emits: [
    "selectionChanged",
    "searchBySubnet",
    "addEquipmentDiscovery",
    "addCredentialsBySnmp",
    "addCredentialsByWmi",
    "deleteCredentialsBySnmp",
    "deleteCredentialsByWmi",
  ],
  data() {
    return {
      inputSearchSubnet: "",
      inputSearchTable: "",
      isDisableButtonAddEquipment: true,
      modalId: "",
      selectedPolicy: "",
      selectedTagList: [],
      selectedEquipmentList: [],
      isEnableMonitor: true,
    }
  },
  computed: {
    PolicyNameList() {
      return this.policyList.map((policy) => policy.name)
    },
    selectedPolicyId() {
      let policyId = ""
      for (let i = 0; i < this.policyList.length; i++) {
        if (this.selectedPolicy === this.policyList[i].name) {
          policyId = this.policyList[i].id
        }
      }
      return policyId
    },
    isDisableButtonSearch() {
      return this.SNMPList.length === 0 && this.WMIList.length === 0
    },
    isDisableInput() {
      return this.SNMPList.length === 0 && this.WMIList.length === 0
    },
  },
  watch: {
    policyList: {
      deep: true,
      handler() {
        const defaultPolicyIndex = this.policyList.findIndex(
          (policy) => policy.name === "Default Policy"
        )
        this.selectedPolicy = this.policyList[defaultPolicyIndex].name
      },
    },
  },
  mounted() {
    if (this.policyList.length) this.selectedPolicy = this.policyList[0].name
  },
  methods: {
    clickButtonSNMPCommunity() {
      this.modalId = "modal-discovery-credential"
      this.$bvModal.show(this.modalId)
    },
    clickButtonSearch() {
      this.$emit("searchBySubnet", this.inputSearchSubnet)
    },
    onRowClick() {},
    selectionChanged(dataTable) {
      this.selectedEquipmentList = dataTable
      if (dataTable.length > 0) {
        this.isDisableButtonAddEquipment = false
      } else {
        this.isDisableButtonAddEquipment = true
        this.$emit("selectionChanged", dataTable)
      }
    },
    clickButtonAddEquipment() {
      this.modalId = "modal-confirm-and-equipment"
      this.$bvModal.show(this.modalId)
    },
    confirmAddEquipment() {
      const request = {
        policyId: this.selectedPolicyId,
        tags: this.selectedTagList,
        equipment: this.selectedEquipmentList,
        enableMonitoring: this.isEnableMonitor,
      }
      this.$emit("addEquipmentDiscovery", request)
    },

    // add credentials
    addCredentialsBySnmp(request) {
      this.$emit("addCredentialsBySnmp", request)
    },
    addCredentialsByWmi(request) {
      this.$emit("addCredentialsByWmi", request)
    },
    deleteCredentialsBySnmp(id) {
      this.$emit("deleteCredentialsBySnmp", id)
    },
    deleteCredentialsByWmi(id) {
      this.$emit("deleteCredentialsByWmi", id)
    },
  },
}
</script>

<style lang="scss" scoped>
.content__data {
  font-size: 12px;
}
.discovery-node__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 5px;
}
.header__text--title {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}

.content__search {
  display: flex;
  align-items: flex-end;
  width: 100%;
  margin-bottom: 10px;
}
.search__input {
  width: 100%;
}
.search__button {
  margin-left: 10px;
}
.content__empty-data {
  height: 510px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.empty-data__icon {
  width: 100px;
  height: 100px;
}

.empty-data__text--title {
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
  margin-top: 20px;
}
.empty-data__text--body {
  color: #b9b9c3;
  font-size: 14px;
  margin-top: 10px;
}

.discovery-node__footer {
  padding-top: 30px;
  flex-wrap: wrap;
}
.footer__text {
  padding-left: 10px;
  font-size: 14px;
}

.organism-discovery_discovery-node {
  width: 100%;
  background: #ffffff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
}

.discovery-node__header {
  padding: 1.5rem 1.5rem 0 1.5rem;
}

.footer__top--content {
  padding: 1.5rem 1.5rem 0 1.5rem;
}

.footer__bottom--content {
  padding: 0 1.5rem 1.5rem 1.5rem;
}

.organism-discovery_discovery-node ::v-deep {
  .molecule-datatable--header-search-container {
    padding: 21px 21px 0 21px;
  }
}

.header__button {
  width: 100%;
}

.footer__select-policy-and-tag {
  padding-left: 0px;
}

.select-policy-topic {
  display: flex;
  justify-content: space-between;
  padding-right: 2px;
}

.info-icon_container {
  display: flex;
  align-items: flex-start;
}

.info-icon--size {
  margin-top: 5px;
  height: 10px;
  width: 10px;
}

.container--center {
  text-align: center;
}

.enable-monitor {
  margin-top: 8px;
}
// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .content__search {
    margin-bottom: 0;
    width: fit-content;
  }
  .search__input {
    width: 330px;
  }
}
// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .footer__select-policy-and-tag {
    padding-left: 10px;
  }
  .header__button {
    width: fit-content;
  }
  .search__input {
    width: 378px;
  }
  .organism-discovery_discovery-node ::v-deep {
    .molecule-datatable--header-search-container {
      justify-content: space-between;
      padding: 0 22px 0 22px;
    }
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
